<h3>Newsletters</h3>
<p-table selectionMode="single" [value]="campaigns">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Type</th>
        <th>Created</th>
        <th>Last updated</th>
        <th>Has HTML</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-campaign>
      <tr [pSelectableRow]="campaign" routerLink="/management/constant-contact-campaign/{{campaign.campaignId}}">
        <td>
          {{campaign.name}}
        </td>

        <td>
            {{campaign.type}}
        </td>
        <td>
            {{campaign.createdAt | date:'dd/MM/yyyy'}}
        </td>
        <td>
            {{campaign.updatedAt | date:'dd/MM/yyyy'}}
        </td>
        <td>
            <span *ngIf="campaign.hasHtmlTemplate">HTML</span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
  </p-table>